import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, allowedRoles = ['superadmin'], redirectTo }) {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    const defaultRedirect = allowedRoles.includes('superadmin') ? '/navo-admin/login' : '/admin/login';
    const loginPath = redirectTo || defaultRedirect;

    if (!token || !user) {
        return <Navigate to={loginPath} replace />;
    }

    try {
        const userData = JSON.parse(user);
        if (!allowedRoles.includes(userData.role)) {
            return <Navigate to={loginPath} replace />;
        }
    } catch (e) {
        return <Navigate to={loginPath} replace />;
    }

    return children;
}
